import React from "react";
import Button, { ButtonProps } from "@material-ui/core/Button";
import { TEMPLATE_URL_EXCEL } from "config/parcel-template";
import useText from "constants/text";

const DownloadTemplateButton: React.FC<ButtonProps> = (props) => {
  const downloadBlob = (url: any, filename: string) => {
    const a = document.createElement("a");
    a.href = url;
    a.download = filename || "download";

    const clickHandler = () => {
      setTimeout(() => {
        URL.revokeObjectURL(url);
        a.removeEventListener("click", clickHandler);
      }, 150);
    };
    a.addEventListener("click", clickHandler, false);
    a.click();

    return a;
  };
  const { text } = useText();

  const downloadTemplate = () => {
    const downloadLink = downloadBlob(TEMPLATE_URL_EXCEL, "TemplateCommandeClient.xlsx");
    document.body.appendChild(downloadLink);
  };

  return (
    <>
      <Button variant="outlined" color="primary" onClick={downloadTemplate} {...props}>
        {text.all.download_template}
      </Button>
    </>
  );
};

export default DownloadTemplateButton;
